import { useState } from 'react';

const Contact = () => {
	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [message, setMessage] = useState('');

	const handleSubmit = async (e) => {
		e.preventDefault();
		const response = await fetch(
			'https://autumn-pond-3e16.kentencroth.workers.dev/',
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ name, email, message }),
			}
		);
		console.log(response);

		if (response.ok) alert('Message sent successfully!');
		else alert('Something went wrong. Please try again.');
	};

	const isFormValid = name && email && message;

	return (
		<section className="contact">
			<div className="contact_wrapper">
				<div className="contact_heading">
					<h2>Contact Me</h2>
				</div>
				<form onSubmit={handleSubmit}>
					<div className="form_info">
						<input
							type="text"
							placeholder="Name"
							value={name}
							onChange={(e) => setName(e.target.value)}
						/>
						<input
							type="email"
							placeholder="Email"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
						/>
					</div>
					<div className="form_message">
						<textarea
							placeholder="Message"
							value={message}
							onChange={(e) => setMessage(e.target.value)}
						></textarea>
					</div>
					<button
						className="submit_button"
						type="submit"
						disabled={!isFormValid}
					>
						Send
					</button>
				</form>
			</div>
		</section>
	);
};

export default Contact;
